import {combine} from 'effector';

import {deactivateStorage, fetchStoragesList} from 'api/profile';
import {createGridTableModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {StorageAccessors, StoragePaginationContent, StorageRawRow} from 'types/profile';

const domain = rootDomain.createDomain('storagesTableDomain');

export const fetchDataFx = domain.createEffect({
    name: 'fetchStoragesListFx',
    handler: fetchStoragesList,
});

export const deactivateStorageFx = domain.createEffect({
    name: 'deactivateStorageFx',
    handler: deactivateStorage,
});

export const {
    filters$,
    filtersChanged,
    filtersReset,
    defaultFilters,
    sortings$,
    sortingsChanged,
    sortingsReset,
    defaultSortings,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    Gate,
    tableStateChanged,
    stateReset,
} = createGridTableModel({
    domain,
    defaultSortings: {
        [StorageAccessors.storageName]: false,
    },
});

export const data$ = domain.createStore<StoragePaginationContent<StorageRawRow> | null>(null);

export const storagesState$ = combine({
    data: data$,
    pageNumber: pageNumber$,
    pageSize: pageSize$,
    filters: filters$,
    sortings: sortings$,
    isLoading: fetchDataFx.pending,
});
